import React from "react";
import Props from "../../models/Properties"
import Form from 'react-bootstrap/Form';

const InputInteger: React.FC<{data: any}> = (props) => {
    const [value, setValue] = React.useState(Props.currentValue(props.data.prop));

    function changeHandler(e: React.ChangeEvent<HTMLInputElement>) {
        let v = Math.trunc(+e.target.value);
        setValue(v);
        props.data.onChange(props.data.prop, v);
    }

    return (
        <>
            <Form.Label>{props.data.prop.title}</Form.Label>
            <Form.Control type="number" value={value} onChange={changeHandler} readOnly={props.data.prop.readOnly}/>
        </>
    );
};

export default InputInteger;
